import styled from 'styled-components'

export const ButtonContainer = styled.button`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    background: ${({ disabled }) => (disabled ? '#ccc' : '#F8B0BB')};
    color: ${({ disabled }) => (disabled ? '#fafafa' : '#202020')};   
    font-size: ${({ fontBig }) => (fontBig ? '20px' : '14px')};
    font-weight: 600;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    border: none;
    outline: none;
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

    &:hover {
        background: ${({ disabled }) => (disabled ? '#ccc' : '#ff91a2')}; 
    }
`